import { createElement } from "react";
import { CountryTransfert } from "../types/features/administration/CountryTransfert";

/**
 * Génère et télécharge le tableau quotidien des taux.
 * @react-pdf/renderer est chargé à la demande pour ne pas alourdir le bundle principal.
 */
export async function downloadDailyRatesPdf(rates: CountryTransfert[], date: Date = new Date()) {
  const [{ pdf }, { default: DailyRatesPdfDocument }] = await Promise.all([
    import("@react-pdf/renderer"),
    import("../components/features/administration/daily-rates/DailyRatesPdfDocument"),
  ]);

  const doc = createElement(DailyRatesPdfDocument, { rates, generatedAt: date });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const blob = await pdf(doc as any).toBlob();

  const pad = (n: number) => String(n).padStart(2, "0");
  const fileName = `TABLEAU QUOTIDIEN DES TAUX - ${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}.pdf`;

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
